var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    {
      directives: [
        {
          name: "loading",
          rawName: "v-loading",
          value: _vm.loading,
          expression: "loading",
        },
      ],
      staticClass: "table",
    },
    [
      _c(
        "virtual-scroll",
        {
          attrs: { data: _vm.segmentData, "item-size": 62, "key-prop": "id" },
          on: { change: (renderData) => (_vm.dataList = renderData) },
        },
        [
          _c(
            "el-table",
            {
              staticClass: "loadmore-table",
              class: _vm.loading ? "no-empty" : "",
              attrs: { stripe: "", data: _vm.dataList, height: "500px" },
            },
            [
              _c("el-table-column", {
                attrs: { align: "center", width: "55px" },
                scopedSlots: _vm._u([
                  {
                    key: "default",
                    fn: function ({ row }) {
                      return [
                        _c("el-checkbox", {
                          staticClass: "checkBox",
                          attrs: { indeterminate: row.isIndeterminate },
                          on: {
                            change: function ($event) {
                              return _vm.handleCheckAllChange(row.index)
                            },
                          },
                          model: {
                            value: row.isCheck,
                            callback: function ($$v) {
                              _vm.$set(row, "isCheck", $$v)
                            },
                            expression: "row.isCheck",
                          },
                        }),
                      ]
                    },
                  },
                ]),
              }),
              _c("el-table-column", {
                attrs: {
                  label: "客户单号",
                  prop: "referenceNumber",
                  align: "center",
                  width: "260px",
                },
              }),
              _c("el-table-column", {
                attrs: {
                  label: "主单号",
                  prop: "mstTrackingNumber",
                  align: "center",
                  width: "200px",
                },
              }),
              _c("el-table-column", {
                attrs: {
                  label: "件数",
                  prop: "children",
                  align: "center",
                  width: "200px",
                },
                scopedSlots: _vm._u([
                  {
                    key: "default",
                    fn: function ({ row }) {
                      return [
                        _vm._v(" " + _vm._s(row.children?.length || 1) + " "),
                      ]
                    },
                  },
                ]),
              }),
              _c("el-table-column", {
                attrs: {
                  label: "上传时间",
                  prop: "uploadTime",
                  align: "center",
                  width: "200px",
                },
              }),
              _c("el-table-column", {
                attrs: { label: "操作", align: "center", width: "150px" },
                scopedSlots: _vm._u([
                  {
                    key: "default",
                    fn: function ({ row }) {
                      return [
                        _c(
                          "el-button",
                          {
                            directives: [
                              {
                                name: "show",
                                rawName: "v-show",
                                value: row.children?.length > 1,
                                expression: "row.children?.length > 1",
                              },
                            ],
                            attrs: { type: "text" },
                            on: {
                              click: function ($event) {
                                return _vm.open(row.index, row.isCollapse)
                              },
                            },
                          },
                          [
                            _vm._v(
                              " " +
                                _vm._s(row.isCollapse ? "收起" : "展开") +
                                " "
                            ),
                          ]
                        ),
                        _c(
                          "div",
                          {
                            directives: [
                              {
                                name: "show",
                                rawName: "v-show",
                                value: row.isCollapse,
                                expression: "row.isCollapse",
                              },
                            ],
                            staticClass: "content",
                          },
                          [
                            _c("div", { staticClass: "title" }, [
                              _vm._v("选择子单号"),
                            ]),
                            _c(
                              "div",
                              {
                                staticClass: "order-items",
                                style: {
                                  width:
                                    _vm.size === "small"
                                      ? "100%"
                                      : "calc(100% - 200px)",
                                },
                              },
                              _vm._l(row?.children, function (order) {
                                return _c(
                                  "div",
                                  {
                                    key: order.trackingNumber,
                                    staticClass: "order",
                                  },
                                  [
                                    _c("el-checkbox", {
                                      on: {
                                        change: function ($event) {
                                          return _vm.handleCheckOrderChange(
                                            row.index
                                          )
                                        },
                                      },
                                      model: {
                                        value: order.isCheck,
                                        callback: function ($$v) {
                                          _vm.$set(order, "isCheck", $$v)
                                        },
                                        expression: "order.isCheck",
                                      },
                                    }),
                                    _c(
                                      "span",
                                      {
                                        staticClass: "lable",
                                        class: [
                                          {
                                            checked: order.isCheck,
                                            uncheck: !order.isCheck,
                                          },
                                        ],
                                      },
                                      [
                                        _vm._v(
                                          " " +
                                            _vm._s(order.trackingNumber) +
                                            " "
                                        ),
                                      ]
                                    ),
                                  ],
                                  1
                                )
                              }),
                              0
                            ),
                          ]
                        ),
                      ]
                    },
                  },
                ]),
              }),
              _c(
                "div",
                { attrs: { slot: "append" }, slot: "append" },
                [
                  _vm.dialogVisible
                    ? _c(
                        "InfiniteLoading",
                        {
                          attrs: {
                            forceUseInfiniteWrapper:
                              ".loadmore-table .el-table__body-wrapper",
                          },
                          on: { infinite: _vm.loadMore },
                        },
                        [
                          _c("span", {
                            attrs: { slot: "no-more" },
                            slot: "no-more",
                          }),
                          _c("span", {
                            attrs: { slot: "no-result" },
                            slot: "no-result",
                          }),
                        ]
                      )
                    : _vm._e(),
                ],
                1
              ),
            ],
            1
          ),
        ],
        1
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }